import { object, string } from 'yup';
import { AddUserModalProps } from 'enums/AddUserModalProps';
interface CategoryOptions {
  value: string;
  label: string;
}
/**
 * Note: These options are now deprecated and kept for reference only.
 * The actual role options should be fetched from the backend API (/user/roles)
 * which returns the publicly available roles: Super Admin, Admin, Data Contributor, Viewer.
 */
export const options: CategoryOptions[] = [
  {
    value: 'superAdmin',
    label: 'Super Admin',
  },
  {
    value: 'admin',
    label: 'Admin',
  },
  {
    value: 'dataContributor',
    label: 'Data Contributor',
  },
  {
    value: 'viewer',
    label: 'Viewer',
  },
];
const phoneRegExp = /^\d{10,15}$/;
export const validationSchema = object({
  name: string().required(AddUserModalProps.ERROR_MESSAGE),
  role: string().required(AddUserModalProps.ERROR_MESSAGE),
  email: string().email().required(AddUserModalProps.ERROR_MESSAGE),
  phone: string().matches(
    phoneRegExp,
    'Phone number must be between 10 and 15 digits and can only contain numbers'
  ),
  position: string().required(AddUserModalProps.ERROR_MESSAGE),
});
